module.exports = __webpack_public_path__ + "img/mastercard.518de273.png";